export default {
  name: 'titlebox',
  components: {},
  props: {"profile": null},
  data () {
    return {
      securityData: null
    }
  },
  mounted () {

  },
  methods: {

  }
}


